    <bizz-grid class="bizz-grid flex h-full w-full flex-col overflow-hidden" [currentPage]="currentPage"
    [gridOptions]="gridOptions" [gridData]="(gridData | async)!" [loading]="loading"
    [totalItems]="((gridResultData$ | async)?.totalItems ?? 0)" 
    (pageChange)="onPageChange($event)" (groupChange)="onGroupChange($event)"
    (sortChange)="onSortChange($event)"                [autoFitColumns]="gridOptions.autoSize"
    ></bizz-grid>